export const ZipCodeMinimumLength = 5;
